import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, unref as _unref, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives } from "vue"

import { type PropType } from 'vue';
import type { RouteLocationRaw } from 'vue-router';
import { goBack } from '@/composables/useNavigation';


export default /*@__PURE__*/_defineComponent({
  __name: 'UiBackButton',
  props: {
    fallbackTo: {
        type: Object as PropType<RouteLocationRaw>,
        required: true,
    },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _directive_tippy = _resolveDirective("tippy")!

  return _withDirectives((_openBlock(), _createBlock(_component_UiButton, {
    "text-variant": "primary",
    "no-border": "",
    "no-shadow": "",
    class: "hover:bg-white/50",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(goBack)(__props.fallbackTo)))
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(_ctx.$t('core.actions.Back')), 1)
    ]),
    _: 1
  })), [
    [_directive_tippy, _ctx.$t('core.actions.Back')]
  ])
}
}

})